/**
 * KOD WYSPY Z JEJ NAZWY — ta sama reguła co w instancji (`api/src/agent-ingest/kod-wyspy.ts`).
 *
 * ⚠️ ISTNIEJE, ŻEBY EKRAN POKAZAŁ TO, CO I TAK POWSTANIE. Kod wylicza instancja i ona rozstrzyga
 * kolizję (dokłada `-2`), więc to tutaj jest wyłącznie podglądem — pole można nadpisać, a treść
 * ostatecznie i tak przechodzi przez serwer. Powtórzenie dziesięciu linii reguły jest tańsze niż
 * pytanie serwera o podpowiedź przy każdym wciśnięciu klawisza.
 *
 * ⚠️ POLSKIE ZNAKI ZAMIENIAMY PRZED odsianiem reszty: bez tego „Zakład Piła" dawałoby
 * `zak-ad-pi-a`, czyli kod wyglądający na uszkodzony — a on trafia do adresów portalu.
 */
const POLSKIE: Record<string, string> = {
  ą: 'a',
  ć: 'c',
  ę: 'e',
  ł: 'l',
  ń: 'n',
  ó: 'o',
  ś: 's',
  ź: 'z',
  ż: 'z',
};

const MAX_KOD = 40;

export function kodZNazwy(nazwa: string): string | null {
  const kod = nazwa
    .trim()
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (z) => POLSKIE[z] ?? z)
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/^[-._]+/, '')
    .replace(/[-._]+$/, '')
    .slice(0, MAX_KOD);

  if (kod.length < 2 || !/^[a-z0-9][a-z0-9._-]*$/.test(kod)) return null;
  return kod;
}
